export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-bold mb-4">
            <i className="ri-information-line"></i>
            关于我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            关于51吃瓜在线
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            <strong className="text-foreground-900">51吃瓜在线</strong>成立于2020年，是国内领先的吃瓜视频内容聚合平台。我们致力于为广大网友提供最新、最全、最热的娱乐八卦视频内容，涵盖<strong className="text-foreground-900">娱乐圈爆料、社会热点追踪、网红动态盘点、综艺节目揭秘</strong>等多个垂直领域。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            平台日均更新200+条高清视频，拥有专业的内容审核团队和编辑团队，确保每一条视频都经过严格筛选。我们坚持<strong className="text-foreground-900">免费观看、高清播放、快速更新</strong>三大原则，为超过千万用户提供优质的在线观看与在线播放体验。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            未来，51吃瓜在线将继续深耕吃瓜视频赛道，拓展更多元的内容形式，打造集视频观看、话题互动、用户投稿于一体的综合性吃瓜社区。吃瓜，就来51吃瓜在线！
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200">
            {[
              { num: '1000万+', label: '累计用户' },
              { num: '200+', label: '日均更新条数' },
              { num: '50万+', label: '视频总量' },
              { num: '99.9%', label: '服务可用率' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-xl md:text-2xl font-black text-primary-600">{stat.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}